module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Spam-69d9812d8ae1fe15a956da9ca0a67f1d.svg";